import { createReducer, on } from '@ngrx/store';
import * as fromLanding from '../actions/landing.actions';
import { Opinion } from '../../../shared/interfaces/opinion';
import { FAQ } from '../../../shared/interfaces/faq';
import { IProduct } from '../../../shared/interfaces/IProduct';

export const landingFeatureKey = 'landing';

export interface State {
  isLoading: boolean;
  opinions: Opinion[];
  productDetail: IProduct;
  error: any;
  FAQS: FAQ[];
  couponDiscount: any;
  couponProducts: IProduct[];
  couponError: any;
  couponLoading: boolean;
}

export const initialState: State = {
  isLoading: false,
  opinions: [],
  FAQS: [],
  error: null,
  productDetail: null,
  couponDiscount: null,
  couponProducts: [],
  couponError: null,
  couponLoading: false,
};

const _Reducer = createReducer(
  initialState,
  on(fromLanding.getProduct, (state) => ({ ...state, isLoading: true })),
  on(fromLanding.getProductSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    productDetail: payload.product,
  })),
  on(fromLanding.getProductError, (state, payload) => ({
    ...state,
    isLoading: false,
    error: payload.error,
    productDetail: null,
  })),
  on(fromLanding.getOpinions, (state) => ({ ...state, isLoading: true })),
  on(fromLanding.getOpinionsSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    opinions: payload.opinions,
  })),
  on(fromLanding.getOpinionsError, (state, payload) => ({
    ...state,
    isLoading: false,
    error: payload.error,
  })),
  on(fromLanding.getFAQS, (state) => ({ ...state, isLoading: true })),
  on(fromLanding.getFAQSSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    FAQS: payload.FAQS,
  })),
  on(fromLanding.getFAQSError, (state, payload) => ({
    ...state,
    isLoading: false,
    error: payload.error,
  })),
  // Reducers para cupones
  on(fromLanding.validateCoupon, (state) => ({
    ...state,
    couponLoading: true,
    couponError: null,
  })),
  on(fromLanding.validateCouponSuccess, (state, payload) => ({
    ...state,
    couponLoading: false,
    couponDiscount: payload.discount,
    couponProducts: payload.products,
    couponError: null,
  })),
  on(fromLanding.validateCouponError, (state, payload) => ({
    ...state,
    couponLoading: false,
    couponError: payload.error,
    couponDiscount: null,
    couponProducts: [],
  })),
  on(fromLanding.clearCoupon, (state) => ({
    ...state,
    couponDiscount: null,
    couponProducts: [],
    couponError: null,
    couponLoading: false,
  }))
);

export function reducer(state, action): State {
  return _Reducer(state, action);
}
